import { render, staticRenderFns } from "./newNotice.vue?vue&type=template&id=415f9bfe&scoped=true&"
import script from "./newNotice.vue?vue&type=script&lang=js&"
export * from "./newNotice.vue?vue&type=script&lang=js&"
import style0 from "./newNotice.vue?vue&type=style&index=0&id=415f9bfe&lang=less&scoped=true&"
import style1 from "./newNotice.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415f9bfe",
  null
  
)

export default component.exports